import {Component, effect, input, output, signal} from '@angular/core';
import {AlertService} from 'sigale-angular';
import {BureauDto} from '../../shared/dto/bureau.dto';
import {IlotDto} from '../../shared/dto/ilot.dto';
import {ReservationService} from '../../shared/services/reservation.service';
import {AuthService} from '../../shared/services/auth-service.service';
import {DateUtilsService} from '../../shared/services/date-utils.service';
import {ReserverBureauDto} from '../model/reserver-bureau.dto';
import {finalize} from 'rxjs/operators';
import {Location} from '@angular/common';
import {Duree} from '../../shared/models/duree.model';

@Component({
	selector: 'app-reserver-bureau-modal',
	templateUrl: './reserver-bureau-modal.component.html',
	styleUrl: './reserver-bureau-modal.component.scss'
})
export class ReserverBureauModalComponent {

	readonly NOM_ALERTE_RESERVER_BUREAU_MODAL = 'alertReserverBureauModal';

	visible = input.required<boolean>();
	bureau = input.required<BureauDto>();
	dateReservation = input.required<Date>();
	duree = input.required<Duree>();
	ilot = input.required<IlotDto>();

	visibleChange = output<boolean>();

	loadingReservation = signal(false);
	visibleLocal = signal(false);

	constructor(
			private alertService: AlertService,
			private reservationService: ReservationService,
			private authService: AuthService,
			private dateUtilsService: DateUtilsService,
			private location: Location) {
		// A chaque modification de visible qui est renseigné par le parent (ex à l'ouverture de la modale) on notifie modifie le visible local
		effect(() => {
			this.visibleLocal.set(this.visible());
		}, {allowSignalWrites: true});

		// Chaque fois que le visible en local est modifié on emit la valeur au parent.
		effect(() => {
			const val = this.visibleLocal();
			this.visibleChange.emit(val);
		});
	}

	/**
	 * Réserve un bureau.
	 */
	reserverBureau() {
		this.loadingReservation.set(true);
		const utilisateurConnecte = this.authService.getUtilisateurConnecte();

		const reserverBureauDto: ReserverBureauDto = {
			dateReservation: this.dateUtilsService.formaterDateEnStringPourEnvoiBack(this.dateReservation(), utilisateurConnecte.langue),
			bureauId: this.bureau().id,
			occupantLogin: utilisateurConnecte.login,
			duree: this.duree()
		};

		this.reservationService.reserverBureau(reserverBureauDto)
			.pipe(finalize(() => this.loadingReservation.set(false)))
			.subscribe({
				next: () => {
					this.fermerModal();
					this.location.back();
				},
				error: (error) => {
					this.alertService.clear(this.NOM_ALERTE_RESERVER_BUREAU_MODAL);
					this.alertService.error(error.error, this.NOM_ALERTE_RESERVER_BUREAU_MODAL);
				}
			});
	}

	/**
	 * Effectue les actions de fermeture de modal
	 */
	fermerModal(): void {
		this.visibleChange.emit(false);
		this.visibleLocal.set(false);
		this.alertService.clear(this.NOM_ALERTE_RESERVER_BUREAU_MODAL);
	}
}
